module.exports = __webpack_public_path__ + "0af5d249/img/comment-question-icon.7dd26e04.svg";